import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../constant/Endpoint";
import useDeleteHook from "../customHooks/useDeleteHook";
import useGetHook from "../customHooks/useGetHook";
import { getKey } from "../helpers/sessionKey";
const DashboardComponent = loadable(() => import("../components/Dashboard"));

const Dashboard = () => {
  const { mutateAsync: deletefolder, isLoading: isDeleting } = useDeleteHook({
    queryKey: ["folder"],
  });
  const id = getKey("user");
  const { data: fileList, isLoading } = useGetHook({
    queryKey: ["file", `file-${id}`],
    url: `${APIS.FILE}`,
    params: {
      object_id: id,
    },
  });
  const { data: folderList, isLoading: isfolderListLoading } = useGetHook({
    queryKey: ["folder"],
    url: `${APIS.FOLDER}`,
    params: {
      parent__isnull: true,
    },
  });

  const { mutateAsync, isLoading: isdeleteLoading } = useDeleteHook({
    queryKey: ["file"],
  });

  const handleDeleteFile = async (id: any) => {
    const url = `${APIS.FILE}${id}/`;
    try {
      await mutateAsync({ url });
    } catch (err) {
      console.error(err);
    }
  };
  const handleDeleteFolder = async (id: any) => {
    const url = `${APIS.FOLDER}${id}/`;
    try {
      await deletefolder({ url });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw`container px-4 mx-auto`}>
      <div>
        <h1 className={tw`text-xl py-2 font-semibold`}>My Drive</h1>
      </div>
      <DashboardComponent
        fileList={fileList}
        folderList={folderList}
        handleDeleteFile={handleDeleteFile}
        handleDeleteFolder={handleDeleteFolder}
        isdeleteLoading={isdeleteLoading}
        isDeleting={isDeleting}
      />
    </div>
  );
};

export default Dashboard;
